import ac from "../images/speakers/Ashish_Chauhan.png"
import by from "../images/speakers/Bhupendra_Yadav.jpg"
import cpr from "../images/speakers/CP_Radhakrishnan.jpg"
import gsm from "../images/speakers/Ganti_S_Murthy.jpg"
import gd from "../images/speakers/Gauranga-Das-Prabhu.png"
import sgm from "../images/speakers/S-Gurumurthy.png"
import hs from "../images/speakers/Hiten-Sethi.jpg"
import rns from "../images/speakers/Radhanath_swami.jpeg"
import vb from "../images/speakers/vardar.jpg"
import rk from "../images/speakers/Raman_Kant.jpg"
import gr from "../images/speakers/Ganesh_Ramakrishnan.jpg"
import CSS from "../images/speakers/Dr.Chetan-Singh-Solanki.jpeg"
import RS from "../images/speakers/Dr.RajendraSingh.jpeg"
import NPP from "../images/dr-narayana-prasad-padhy.jpeg";
import VS from "../images/dr-vishal-sardeshpande.jpeg"
import DVP from "../images/dr.-vishwanath-srikantaiah.jpeg";
import AC from "../images/aarya-vhavda.jpeg"
import CS from "../images/speakers/chandramouli-subramaniam.jpeg"
import SNT from "../images/speakers/sachchida.jpeg"
import srs from "../images/speakers/shri-ranpal-singh.jpeg"
import AG from "../images/speakers/anuradda_ganesh.jpeg"

const CommitteeMembers = {
  advisory: [
    { name: 'Radhanath swami', image: rns, designation: 'Spiritual Leader, Teacher, Author', link: 'https://www.radhanathswami.com/about-radhanath-swami/' },
    { name: 'Chetan Singh Solanki', image: CSS, designation: 'Solar Man of India, Founder-Energy Swaraj', link: 'https://www.linkedin.com/in/drchetansolanki/?originalSubdomain=in' },
    { name: 'Shri Rajendra Singh', image: RS, designation: 'Water Man of India, Environmentalist', link: 'https://en.wikipedia.org/wiki/Rajendra_Singh' },
    { name: 'Gauranga Das', image: gd, designation: 'Director, Govardhan eco village' },
    { name: 'Shri Ranpal Singh', image: srs, designation: 'Group Head-Collaboration & Innovation, TATA Power', link: "https://www.linkedin.com/in/ranpalsingh126/?originalSubdomain=in" },
    { name: 'Shri Vishwanath Srikantaiah', image: DVP, designation: "Rain Man of Bengaluru, Environmentalist" },

  ],
  panelists: [
    // { name: 'Narayan padhy', image: NPP, designation: "President, Bharatiya Nadi Parishad" },
    { name: 'Shri Vishal Sardeshpande', image: VS, designation: 'Founder, SARVAAY Solutions LLP', link: 'https://www.ctara.iitb.ac.in/en/faculty-profile/prof-vishal-r-sardeshpande' },
    { name: 'Ms. Aarya Chavda', image: AC, designation: 'Author, Illustrator, Heritage & EnvironmentCrusader' },
    { name: 'Shri Chandramouli Subramaniam', image: CS, designation: 'Professor, IIT Bombay', link: "https://www.chem.iitb.ac.in/facultyuserview/c-subramaniam" },
    { name: 'Shri Sachchida Nand Tripathi', image: SNT, designation: 'Dean, KSS, IIT Kanpur', link: "https://home.iitk.ac.in/~snt/#/home" },
    { name: 'Shri Anuradda Ganesh', image: AG, designation: 'Adjunct Professor-IIT Madras, Director-Arantree Consulting' },

  ]
};


export default CommitteeMembers;